import { render, staticRenderFns } from "./PagesWrap.vue?vue&type=template&id=3329af74&scoped=true&"
import script from "./PagesWrap.vue?vue&type=script&lang=js&"
export * from "./PagesWrap.vue?vue&type=script&lang=js&"
import style0 from "./PagesWrap.vue?vue&type=style&index=0&id=3329af74&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3329af74",
  null
  
)

export default component.exports